import React from "react";

import DefaultTextOnlyBanner from "@sendmagic/prismic-nextjs/src/components/TextOnlyBanner/variations/Default";
import TextOnlyBannerVersionTwo from "@sendmagic/prismic-nextjs/src/components/TextOnlyBanner/variations/Version-2";

const VARIANT = "v2";

const TextOnlyBanner = ({ doc, ...rest }) => {
  const { slice_label } = doc;
  return slice_label === VARIANT ? (
    <TextOnlyBannerVersionTwo doc={doc} {...rest} />
  ) : (
    <DefaultTextOnlyBanner doc={doc} {...rest} />
  );
};

export default TextOnlyBanner;
